module.exports = __webpack_public_path__ + "img/IMG_9621_L_BlackMatted_MockedUp.03521c8d.jpg";